(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const $ = s => root.querySelector(s);
    const words = JSON.parse($('[data-gallery-translations]').textContent);
    const products = JSON.parse($('[data-gallery-products]').textContent);
    const grid = $('[data-gallery-grid]'), viewer = $('[data-gallery-viewer]');
    const state = { groups: [], listing: [], group: null, image: 0, trigger: null };
    const category = root.dataset.category;
    function node(tag, className, text) { const e = document.createElement(tag); if (className) e.className = className; if (text) e.textContent = text; return e; }
    function purchase(group) {
      if (!group.store) return null;
      const p = products[group.productHandle];
      const box = node('div', 'cdv-artwork-purchase');
      const sold = group.commissionOnly || p && !p.available;
      if (sold) {
        box.classList.add('is-sold');
        box.append(node('p', 'cdv-artwork-sold', words.sold));
        box.append(node('p', '', words.sold_message));
        const price = p?.price || new Intl.NumberFormat(root.dataset.locale === 'es' ? 'es-CO' : 'en', { style: 'currency', currency: group.currency || 'COP', maximumFractionDigits: 0 }).format(Number(group.price));
        if (price && Number(group.price) > 0 || p?.price) box.append(node('p', 'cdv-artwork-reference', words.reference_price + ': ' + price));
        const a = node('a', 'cdv-artwork-buy', words.create_yours);
        a.href = root.dataset.root + (root.dataset.root.endsWith('/') ? '' : '/') + 'pages/cdv-contact';
        box.append(a); return box;
      }
      if (!p) return null;
      box.append(node('p', '', p.price));
      const a = node('a', 'cdv-artwork-buy', root.dataset.locale === 'es' ? 'Ver pieza' : 'View piece');
      a.href = p.url; box.append(a);
      return box;
    }

    function updateUrl() {
      const q = new URLSearchParams();
      if (state.group) q.set('artwork', state.group.id);
      const hash = q.toString() ? '#' + q.toString() : '';
      history.pushState(null, '', location.pathname + location.search + hash);
    }
    function scrollToGallery() {
      const target = state.group ? $('[data-gallery-navigation]') || $('[data-gallery-group-title]') : grid;
      target.scrollIntoView({ block: 'start', behavior: 'auto' });
    }
    function openGroup(group, trigger) {
      state.group = group; state.trigger = trigger;
      render(); updateUrl(); scrollToGallery();
      $('[data-gallery-group-title]').focus({ preventScroll: true });
    }
    function imageButton(image, group, index, detail) {
      const b = node('button', 'cdv-artwork-image'); b.type = 'button';
      b.setAttribute('aria-label', detail ? group.title + ' — ' + words.photo + ' ' + (index + 1) : group.title);
      const img = node('img'); img.src = image.src + (image.src.includes('?') ? '&' : '?') + 'width=1000';
      img.alt = image.alt; img.loading = index < 4 ? 'eager' : 'lazy'; img.width = 1000; img.height = 1000;
      b.append(img);
      b.addEventListener('click', () => detail ? openViewer(index, b) : openGroup(group, b));
      return b;
    }
    function render() {
      const group = state.group, items = group ? group.images : state.listing;
      root.classList.toggle('is-viewing-group', !!group);
      grid.replaceChildren(); grid.classList.toggle('is-group', !!group);
      $('[data-gallery-back]').hidden = !group;
      const navigation = $('[data-gallery-navigation]');
      if (navigation) navigation.hidden = !group;
      $('[data-gallery-group-title]').hidden = !group;
      $('[data-gallery-group-title]').textContent = group ? group.title : '';
      $('[data-gallery-title]').hidden = !!group;
      $('[data-gallery-intro]').hidden = !!group;
      $('[data-gallery-description]').textContent = group ? group.images.length + ' ' + (group.images.length === 1 ? words.photo.toLowerCase() : words.photos) : '';
      $('[data-gallery-purchase]').replaceChildren();
      if (group) { const p = purchase(group); if (p) $('[data-gallery-purchase]').append(p); }
      items.forEach((item, index) => {
        const g = group || item, image = group ? item : item.images?.[0];
        if (!image) return;
        const card = node(group ? 'figure' : 'article', 'cdv-artwork-card' + (group ? ' is-photo' : ''));
        card.dataset.code = image.code; card.dataset.group = g.id;
        card.append(imageButton(image, g, index, !!group));
        if (group) { if (image.title?.trim()) card.append(node('figcaption', '', image.title.trim())); }
        else {
          card.append(node('h3', '', g.title), node('p', '', g.images.length + ' ' + (g.images.length === 1 ? words.photo.toLowerCase() : words.photos)));
          const p = purchase(g); if (p) card.append(p);
        }
        grid.append(card);
      });
      $('[data-gallery-status]').textContent = items.length ? '' : words.empty;
    }
    function showImage() {
      const g = state.group, i = g.images[state.image];
      $('[data-viewer-image]').src = i.src;
      $('[data-viewer-image]').alt = i.alt;
      const caption = $('[data-viewer-caption]');
      caption.textContent = i.title?.trim() || '';
      caption.hidden = !caption.textContent;
      $('[data-viewer-previous]').disabled = g.images.length < 2;
      $('[data-viewer-next]').disabled = g.images.length < 2;
    }
    function openViewer(index, trigger) { state.image = index; state.trigger = trigger; showImage(); viewer.showModal(); document.documentElement.style.overflow = 'hidden'; }
    function moveImage(delta) { state.image = (state.image + delta + state.group.images.length) % state.group.images.length; showImage(); }
    $('[data-viewer-close]').addEventListener('click', () => viewer.close());
    $('[data-viewer-previous]').addEventListener('click', () => moveImage(-1));
    $('[data-viewer-next]').addEventListener('click', () => moveImage(1));
    viewer.addEventListener('close', () => { document.documentElement.style.overflow = ''; state.trigger?.focus({ preventScroll: true }); });
    viewer.addEventListener('keydown', e => { if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); moveImage(e.key === 'ArrowLeft' ? -1 : 1); } });
    $('[data-gallery-back]').addEventListener('click', () => {
      state.group = null; render(); updateUrl(); scrollToGallery();
    });
    function restore() {
      const q = new URLSearchParams(location.hash.slice(1)), id = q.get('artwork') || (new URLSearchParams(location.search).get('view') === 'cdv-zen-gardens' ? 'zen-gardens' : null);
      state.group = state.listing.find(g => g.id === id) ||
        (category === 'living-branch' ? state.groups.find(g => g.id === 'living-branch') :
        category === 'art-and-friends' ? state.listing[0] : null);
      render();
    }
    window.addEventListener('popstate', restore);
    fetch(root.dataset.source).then(r => { if (!r.ok) throw Error(r.status); return r.json(); }).then(data => {
      state.groups = (category === 'mobiles' && Array.isArray(data.mobileGroups) ? data.mobileGroups : data.groups).map(group => ({ ...group, title: root.dataset.locale === 'es' ? group.titleEs || group.title : group.title, images: group.images.map(image => ({ ...image, alt: (root.dataset.locale === 'es' ? group.titleEs || group.title : group.title) + ' — ' + words.photo + ' ' + image.code })) }));
      state.listing = state.groups.filter(g => category === 'our-art' || category === 'store' && g.store || category === 'living-branch' && g.id === 'living-branch' || g.categories.includes(category));
      restore();
    }).catch(() => { $('[data-gallery-status]').textContent = words.error; });
  }
  document.querySelectorAll('[data-cdv-artwork]').forEach(init);
  document.addEventListener('shopify:section:load', () => document.querySelectorAll('[data-cdv-artwork]').forEach(init));
})();




